<template>
    <div class="menu-box">
        <ul class="menu-view">
            <li>
                <span>
                    <img src="https://c2bt4.maxuscloud.com/record2mongo/Record2MongoApi/images/839a7303a8d04e6ebf56ccbe944783b1.png" alt="">
                </span>
                <i>车辆订单</i>
            </li>
            <li>
                <span>
                    <img src="https://c2bt4.maxuscloud.com/record2mongo/Record2MongoApi/images/839a7303a8d04e6ebf56ccbe944783b1.png" alt="">
                </span>
                <i>车辆订单</i>
            </li>
            <li>
                <span>
                    <img src="https://c2bt4.maxuscloud.com/record2mongo/Record2MongoApi/images/839a7303a8d04e6ebf56ccbe944783b1.png" alt="">
                </span>
                <i>车辆订单</i>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        
    },
    data () {
        return {
            
        }
    },
    created () {

    },
    methods: {
        
    },
}
</script>

<style lang="less" src="../../stylesNewUI/pc.less"></style>
<style lang="less">
.menu-box{
    width: 230px;
    .menu-view{  
        width: 100%;
        li{ 
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            padding-left: 30px;
            width: 100%;
            height: 80px;
            background: url("../../assets/menuli.png") no-repeat left center;
            background-size: auto 100%;
            &:last-child{
                margin-bottom: 0;
            }
        }
        span{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 15px;
            width: 30px;
            height: 30px;
            img{
                max-width: 100%;
                max-height: 100%;
            }
        }
        i{
            font-size: 26px;
            color: #fff;
        }
    }
}
</style>
